import { render, staticRenderFns } from "./TechnicalErrorList.vue?vue&type=template&id=0bfe71e4&scoped=true"
import script from "./TechnicalErrorList.vue?vue&type=script&lang=js"
export * from "./TechnicalErrorList.vue?vue&type=script&lang=js"
import style0 from "./TechnicalErrorList.vue?vue&type=style&index=0&id=0bfe71e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe71e4",
  null
  
)

export default component.exports